module.exports = __webpack_public_path__ + "static/img/Albon.3eeb6b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Albon.jpg
// module id = 4gfN
// module chunks = 1